import { Locale } from 'modules/domains/template';
import { BaseOption } from 'ui/selects';

import { MEDIUM_TYPE_SLUGS } from '../../constants';
import { EmailSender, MEDIUM_TYPES, MessageType, SmsSender } from '../../types';

export const mapMessageTypesToOptions = (messageTypes: MessageType[] = []) =>
  messageTypes.map(
    ({ id, name }): BaseOption<number> => ({
      id: `${name}-${id}`,
      label: name,
      value: id,
    }),
  );

export const mapSMSSendersToOptions = (smsSenders: SmsSender[] = []): BaseOption<number>[] =>
  smsSenders.map(({ name, id }) => ({
    id: `${name}-${id}`,
    value: id,
    label: name,
    doubleLine: `id: ${id}`,
  }));

export const mapEmailSendersToOptions = (emailSenders: EmailSender[] = []): BaseOption<string>[] =>
  emailSenders.map(({ email, senderName }) => ({
    id: email,
    value: email,
    label: senderName,
    doubleLine: email,
  }));

export const getMessageMediumSlug = (messageMedium: string): string => {
  return MEDIUM_TYPE_SLUGS[messageMedium as MEDIUM_TYPES] ?? messageMedium;
};

export const mapLocalesToTag = (templateLocales: Locale[]): string[] =>
  templateLocales?.map((val) => val.tag) || [];

/** Remove default locale from secondary locales to copy list, expected by BE */
export const removeDefaultLocale = (templateLocales: string[], defaultLocale: Locale) => {
  const locales = [...templateLocales];
  return locales.filter((locale) => locale !== defaultLocale.tag || '');
};
